import { render } from "./Recipe.vue?vue&type=template&id=50773f17"
import script from "./Recipe.vue?vue&type=script&lang=js"
export * from "./Recipe.vue?vue&type=script&lang=js"
script.render = render

export default script